import { KnockErrorBoundary } from "@src/appV2/Knock/components/KnockErrorBoundary";

import { useEmitReviewPromptAttributes } from "./useEmitReviewPromptAttributes";

function ReviewPromptAttributesEmitterInner(): null {
  useEmitReviewPromptAttributes();
  return null;
}

/**
 * Headless mount point for the rating-prompt user-attribute emitter. Sibling
 * of `ReviewPromptGuide` inside `KnockGuidesConsumers`. The hook waits for the
 * Knock client to authenticate before reading or writing user attributes.
 */
export function ReviewPromptAttributesEmitter(): JSX.Element {
  return (
    <KnockErrorBoundary>
      <ReviewPromptAttributesEmitterInner />
    </KnockErrorBoundary>
  );
}
